module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-qr-code"
  }, [_c('div', {
    staticClass: "con-r-one-tl"
  }, [_c('img', {
    attrs: {
      "src": "//official.cdn.qiyewan.com/border---.png",
      "alt": "qrcode"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "con-r-one-bl"
  }, [_c('img', {
    attrs: {
      "src": "//official.cdn.qiyewan.com/border---.png",
      "alt": "qrcode"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "con-r-one-tr"
  }, [_c('img', {
    attrs: {
      "src": "//official.cdn.qiyewan.com/border---.png",
      "alt": "qrcode"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "con-r-one-br"
  }, [_c('img', {
    attrs: {
      "src": "//official.cdn.qiyewan.com/border---.png",
      "alt": "qrcode"
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("企业湾  创业干货分享")]), _vm._v("p\n  "), _c('p', [_vm._v("关注企业湾，收听和分享更多创业讯息")]), _vm._v(" "), _c('div', {
    staticClass: "qrcode"
  }, [_c('div', {
    staticClass: "qrcode_tl"
  }, [_c('img', {
    attrs: {
      "src": "//official.cdn.qiyewan.com/boeder---.png",
      "alt": "qrcode"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "qrcode_bl"
  }, [_c('img', {
    attrs: {
      "src": "//official.cdn.qiyewan.com/boeder---.png",
      "alt": "qrcode"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "qrcode_tr"
  }, [_c('img', {
    attrs: {
      "src": "//official.cdn.qiyewan.com/boeder---.png",
      "alt": "qrcode"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "qrcode_br"
  }, [_c('img', {
    attrs: {
      "src": "//official.cdn.qiyewan.com/boeder---.png",
      "alt": "qrcode"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "wechat",
    attrs: {
      "src": require("../../assets/wechat-qrcode.jpg"),
      "alt": "qrcode"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "beizhu"
  }, [_vm._v("携手企业湾，为您提供中小企业"), _c('br'), _vm._v("专业项目服务服务")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b3b4fcf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/article/QrCode.vue
// module id = 1016
// module chunks = 40